import React, { Component } from "react";
import "./index.scss";

export default class Main extends Component {
	render() {
		const { sidebarVisible, children, sideDrawerVisible } = this.props;

		return (
			<div className={sidebarVisible ? (sideDrawerVisible ? 'main-wrapper content-side-drawer-visible' : 'main-wrapper') : (sideDrawerVisible ? 'main-wrapper main-wrapper-60 content-side-drawer-visible' : 'main-wrapper main-wrapper-60')} id="wfr-main-wrapper">
				{children}
			</div>
		);
	};
};